// v9 (BOLT-020): the style is SERVER-SERVED — one styling source for the web
// client and the v10 native client. The builder moved to src/shared/mapstyle.ts;
// the MapTiler key left the client bundle entirely (server env `MAPTILER_API_KEY`).
// Every map surface points at this URL; the server answers with the keyed
// "Bolt Field" style or the keyless fallback (tests/dev without a key).
export const MAP_STYLE_URL = '/api/mapstyle';
